// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".durability-form .col-sm-6:last-child{margin-top:1rem}", "",{"version":3,"sources":["webpack://./resources/src/pages/HeroSaga/Equipment/DurabilityForm/DurabilityForm.scss"],"names":[],"mappings":"AAAA,sCACI,eACJ","sourcesContent":[".durability-form .col-sm-6:last-child {\n    margin-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
